/** La sélection est immuable pendant la vie du document, même pendant une sauvegarde différée. */
let actorId: string | null = null;
let selected: string | null = null;
const key = (userId: string) => `ndrc:class-selection:${userId}`;
export function initializeClassSelection(userId: string, classes: readonly { id: string }[]): void {
  if (actorId === userId) return;
  actorId = userId;
  let saved: string | null = null;
  try {
    saved = sessionStorage.getItem(key(userId));
  } catch {
    /* Le premier choix reste accessible sans stockage. */
  }
  selected = classes.find((item) => item.id === saved)?.id ?? classes[0]?.id ?? null;
}
export function classSelection(): string | null {
  return selected;
}
export function switchClassSelection(userId: string, classId: string): void {
  sessionStorage.setItem(key(userId), classId);
  // Une mission de l’ancienne classe ne doit pas remplacer la nouvelle sélection au redémarrage.
  sessionStorage.removeItem(`ndrc:mission-selection:${userId}`);
  window.location.assign('/');
}
